import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const TransactionsSummaryDeskTopStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperContainer: {
      height: "100%",
      [theme.breakpoints.up("md")]: {
        borderRadius: "12px",
        width: "510px",
        height: "auto",
        position: "absolute" as "absolute",
        top: "50%",
        transform: "translate(-50%, -50%)",
        left: "calc(100vw - 45%)",
      },
    },
    TableCellDiv: { display: "flex", alignItems: "center" },
    loading: {
      padding: "20px",
      width: "100vh",
    },
    titleGrid: {
      background: theme.palette.primary.main,
      justifyContent: "center",
      alignItems: "center",
      height: "60px",
      [theme.breakpoints.up("md")]: {
        background: theme.palette.primary.main,
        justifyContent: "center",
        alignItems: "center",
        height: "60px",
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
      },
    },
    title: {
      fontSize: "19px",
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.common.white,
      textAlign: "center",
    },
    exportBox: {
      padding: "24px 28px",
    },
    categoryTitle: {
      textAlign: "start",
      fontSize: "14px",
      fontWeight: theme.typography.fontWeightBold,
      justifyContent: "center",
    },
    radioGroup: {
      justifyContent: "space-between",
      marginBottom: "28px",
    },
    card: {
      borderRadius: "10px",
      padding: "6px 12px",
      width: "221px",
      height: "auto",
      border: "1px solid #E5E7E8",
      boxShadow: "none",
      marginTop: "12px",
      alignItems: "baseline",
      "&:hover": {
        border: theme.palette.mode === "light" ? "1px solid #002035" : "1px solid #5e5e5e",
        background: theme.palette.mode === "light" ? "#F8F9F9" : "#5e5e5e",
      },
    },
    cardSelected: {
      borderRadius: "10px",
      padding: "6px 12px",
      width: "221px",
      height: "auto",
      boxShadow: "none",
      marginTop: "12px",
      alignItems: "baseline",
      background: theme.palette.mode === "light" ? "#E5E9EB" : "#5e5e5e",
      "&:hover": {
        border: theme.palette.mode === "light" ? "1px solid #002035" : "1px solid #aeaeae",
      },
    },
    cardtypography: {
      display: "flex",
      fontSize: "14px",
      alignItems: "center",
      marginBottom: "6px",
      textAlign: "center",
      justifyContent: "center",
      //paddingLeft: "20px",
      color: "#7b858b",
    },
    toggleButtonGroup: {
      marginTop: "14px",
    },
    toggleButton: {
      padding: "4px 8px",
      fontSize: "14px",
      textTransform: "none",
      color: "#bdc2c5",
      border: "solid 1px #e5e7e8",
      borderRadius: "20px",
      width: "auto",
      height: "25px",
      marginBottom: "8px",
      marginRight: "8px",
      "&:hover": {
        background: theme.palette.common.white,
        border: "1px solid #002035",
        color: "#002035",
      },
    },
    gridContainerdatePicker: {
      borderRadius: "8px",
      background: theme.palette.primary.contrastText,
      padding: "8px 12px",
      height: "35px",
      alignContent: "center",
      marginTop: "8px",
      marginBottom: "8px",
    },
    gridContainernotes: {
      height: "52px",
      width: "454px",
      background: theme.palette.primary.contrastText,
      border: "solid 0.5px #002035",
      borderRadius: "10px",
      padding: "8px 12px",
      marginBottom: "28px",
    },
    cancelButton: {
      width: "72px",
      height: "35px",
      padding: "8px 12px",
      background: "#bdc2c5",
      borderRadius: "4px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#002035",
      textTransform: "none",
    },
    exportButton: {
      background: theme.palette.secondary.main,
      borderRadius: "4px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#fff",
      textTransform: "none",
      width: "100%",
      "&:hover": {
        background: theme.palette.primary.main,
      },
      "&.Mui-disabled": {
        background: "#FFF",
        color: "#000",
        border: "1px solid darkgrey",
      },
    },
    container: {
      backgroundColor: "#FFFFFF",
      borderRadius: "12px",
      overflow: "hidden",
    },
    titleRowStyle: {
      borderBottom: "2px solid #002035",
    },
    rowStyle: {
      borderBottom: "1px solid #eaeaea",
      "&:focus": {
        backgroundColor: "#EAEAEA",
      },
    },
    toolBarContainer: {
      justifyContent: "space-between",
      padding: "0px 0 14px 0",
      display: "flex",
      flexDirection: "row",
      lineHeight: "48px",
    },
    selectParent: {
      color: "#545454",
      fontFamily: theme.typography.fontFamily,
      fontSize: "16px",
      lineHeight: "22px",
      width: "115px",
      height: "100%",
    },
    selectText: {
      display: "flex",
      flexDirection: "row",
      placeItems: "center",
    },
    button: {
      marginLeft: "10px",
      width: "156px",
      height: "48px",
      borderRadius: "6px",
      boxShadow: " 0px 10px 20px rgba(203, 118, 118, 0.5)",
      backgroundColor: theme.palette.secondary.main,
      textTransform: "none",
      transition: "background 0.5s, color 0.5s",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: "#fff",
      },
    },
    clearButton: {
      marginLeft: "100px",
      width: "48px",
      height: "48px",
      borderRadius: "6px",
      boxShadow: " 0px 10px 20px rgba(203, 118, 118, 0.5)",
      backgroundColor: theme.palette.secondary.main,
      textTransform: "none",
      transition: "background 0.5s, color 0.5s",
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: "#fff",
      },
    },

    clearText: {
      color: "#FFFFFF",
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightBold,
    },
    exportText: {
      color: "#FFFFFF",
      fontSize: "16px",
      lineHeight: "19px",
      textAlign: "left",
      fontWeight: theme.typography.fontWeightBold,
      marginRight: "15px",
    },
    smallButtonTransaction: {
      marginTop: "5px",
      border: "0px",
      whiteSpace: "nowrap",
      borderRadius: "20px !important",
      color: "#545454",
      height: "40px",
      // minWidth: "105px",
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: "16px",
      textAlign: "center",
      textTransform: "none",
      padding: "0 8px 0 8px",
      marginRight: "5px",
    },
    smallButton: {
      marginTop: "10px",
      border: "0px",
      borderRadius: "20px !important",
      color: "#545454",
      height: "30px",
      width: "100px",
      fontFamily: theme.typography.fontFamily,
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "19px",
      textAlign: "center",
      textTransform: "none",
      padding: "0px",
    },
    root: {
      "& .Mui-selected": {
        // marginTop: "10px",
        fontWeight: 600,
        fontSize: "16px",
        backgroundColor: "#fc4c4c  !important",
        boxShadow: "0px 6px 12px rgba(253, 139, 139, 0.5)",
        color: "#ffffff !important",
        textTransform: "none",
      },
    },
    currencyButton: {
      border: "1px solid #A3A3A3",
      borderRadius: "6px",
      width: "115px",
      height: "48px",
      padding: "20px",
    },
    spinnerStyle: {},
    buttonText: {
      fontSize: "16px",
    },
    buttonContainer: {
      height: "48px",
      marginBottom: "5px",
    },
    subtitle: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#5C6469",
      marginBottom: "10px",
    },
    radio: {
      padding: "9px 5px 9px 0px",
      "& .MuiSvgIcon-root": { fontSize: 18 },
    },
  }),
);
